import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { ReactComponent as CloudUploadSVG } from 'src/components/Icons/assets/cloud-upload.svg'
import { ReactComponent as CsvSVG } from 'src/components/Icons/FileType/csv-icon.svg'
import { ReactComponent as ExcelSVG } from 'src/components/Icons/FileType/excel-icon.svg'
import { ReactComponent as ImageSVG } from 'src/components/Icons/FileType/image-icon.svg'
import { ReactComponent as NumbersSVG } from 'src/components/Icons/FileType/numbers-icon.svg'
import { ReactComponent as KeyNoteSVG } from 'src/components/Icons/FileType/keynote-icon.svg'
import { ReactComponent as PagesSVG } from 'src/components/Icons/FileType/pages-icon.svg'
import { ReactComponent as PdfSVG } from 'src/components/Icons/FileType/pdf-icon.svg'
import { ReactComponent as PowerpointSVG } from 'src/components/Icons/FileType/powerpoint-icon.svg'
import { ReactComponent as WordSVG } from 'src/components/Icons/FileType/word-icon.svg'
import { ReactComponent as TextSVG } from 'src/components/Icons/FileType/text-icon.svg'
import { ReactComponent as CloseSVG } from 'src/components/Icons/Basic/icons_close.svg'

export const FilePickerLabel = styled.label`
  font-weight: 500;
  font-size: 16px;
  line-height: 150%;
`

export const FilePickerContainer = styled.div<{ backgroundImage?: string }>`
  display: flex;
  gap: 8px;
  border: 1px solid ${palette.neutral[300]};
  height: 350px;
  width: 100%;
  flex-grow: 1;
  border-radius: 20px;
  padding: 16px;
  transition: all 0.15s;
  overflow: hidden;
  ${({ backgroundImage }) =>
    backgroundImage
      ? `
    background-image: ${backgroundImage};
    justify-content: space-between;
    align-items: flex-start;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    `
      : `
    flex-direction: column;
    justify-content: center;
    align-items: center;
    `}

  &.isdragging {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px dashed ${palette.neutral[500]};
    background: ${palette.neutral[100]};
  }
`

export const FilePickerContainer__label = styled.label`
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
`

export const FilePickerContainer__TextLight = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  font-style: normal;
  color: ${palette.neutral[400]};
`

export const FilePickerContainer__TextBold = styled.p`
  font-weight: 700;
  font-size: 12px;
  line-height: 21px;
  color: ${palette.neutral[900]};
  text-transform: uppercase;
`

export const FilePickerContainer__Text = styled.p`
  font-weight: 500;
  font-size: 12px;
  line-height: 21px;
  font-style: normal;
  color: ${palette.neutral[900]};
`

export const UploadIcon = styled(CloudUploadSVG)`
  width: 48px;
  height: 48px;
`
export const HiddenFileInput = styled.input`
  display: none;
`
export const CsvIcon = styled(CsvSVG)`
  width: 32px;
  height: 32px;
`

export const ExcelIcon = styled(ExcelSVG)`
  width: 32px;
  height: 32px;
`

export const ImageIcon = styled(ImageSVG)`
  width: 32px;
  height: 32px;
`

export const NumbersIcon = styled(NumbersSVG)`
  width: 32px;
  height: 32px;
`

export const KeyNoteIcon = styled(KeyNoteSVG)`
  width: 32px;
  height: 32px;
`

export const PagesIcon = styled(PagesSVG)`
  width: 32px;
  height: 32px;
`

export const PdfIcon = styled(PdfSVG)`
  width: 32px;
  height: 32px;
`

export const PowerpointIcon = styled(PowerpointSVG)`
  width: 32px;
  height: 32px;
`

export const WordIcon = styled(WordSVG)`
  width: 32px;
  height: 32px;
`

export const TextIcon = styled(TextSVG)`
  width: 32px;
  height: 32px;
`

export const CloseIcon = styled(CloseSVG)`
  width: 12px;
  height: 12px;
  cursor: pointer;
  fill: ${palette.neutral[400]};
  & * {
    fill: ${palette.neutral[400]};
  }
`
export const ErrorMessage = styled.p`
  color: ${palette.magenta[600]};
  font-size: 12px;
`
export const SelectedFileLabel = styled.p`
  font-weight: 400;
  font-size: 24px;
  color: ${palette.neutral[400]};
`
